import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormGroup from '@mui/material/FormGroup';
import style from './brand-market-list.module.css';
import LoadingButton  from '@mui/lab/LoadingButton';
import EastIcon from '@mui/icons-material/East';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { getLocalStoreItem, setLocalStoreItem } from '../../../../helpers/localStoreHandler';
import { SET_BRAND_LOCALE } from '../../../../actions/types';
import { getBrandLocaleData } from '../../utils/brand-locale';
// import { useState } from 'react';

const BrandMarketList = () => {
  const dispatch = useDispatch();
  const getBrandInfo = useSelector(state => state.LocaleSelector);
  const [showSubmit, setShowSubmit] = useState(false);
  const [brandData, setBrandData] = useState([]);
  const [localeData, setLocaleData] = useState([]);
  const [formData, setFormData] = useState({
        brand: {
            value: '',
            label: ''
        },
        locale: {
            value: '',
            label: ''
        }
   });
   const getLocale = getLocalStoreItem('bmpSelectedLocale');

   

  const handleChange = (event, name) => {
    setFormData(prev => {
        return {
            ...prev,
            [name]: { ...event }
        }
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (formData.brand.value && formData.locale.value) {
        dispatch({ 
            type: SET_BRAND_LOCALE, 
            payload: {
                brand: {...formData.brand}, 
                locale: {...formData.locale}
            } 
        });
        setLocalStoreItem('bmpSelectedLocale', JSON.stringify(formData));
        localStorage.removeItem('pdpFaqChangesState');
    }
  };

  useEffect(() => {
    let isMounted = true
    if (getLocale && isMounted) {
        const data = JSON.parse(getLocale);
        if ((data.brand.value !== formData.brand.value)) {
            setShowSubmit(true);
        } else if (data.locale.value !== formData.locale.value) {
            setShowSubmit(true);
        } else {
            setShowSubmit(false);
        }
    }
    return () => {
        isMounted = false; // Cleanup function to set flag to false
    };
  }, [getLocale, formData]);

  useEffect(()=>{
    let isMounted = true;
    if (isMounted) {
        if (getLocale) {
            const data = JSON.parse(getLocale);
            setFormData({...data});
        } else {
            setFormData({
                brand: {
                    value: getBrandInfo.brand.value,
                    label: getBrandInfo.brand.label
                },
                locale: {
                    value: getBrandInfo.locale.value,
                    label: getBrandInfo.locale.label
                }
            })
        }
    }
    return () => {
      isMounted = false; // Cleanup function to set flag to false
    };
  },[getBrandInfo, getLocale, dispatch]);

  useEffect(() => {
    let isMounted = true;
    const loadData = async () => {
        const result = await getBrandLocaleData();
        if (isMounted) {
            setBrandData(result.brands);
            setLocaleData(result.brandLocales);
        }
    };
    if (isMounted) {
        loadData();
    }
    return () => {
      isMounted = false; // Cleanup function to set flag to false
    };
  },[]);

  const emptyLocale = [{value: '', label: ''}];
  const localeOptions = Object.keys(localeData)?.length > 0 ? formData?.brand?.value ? localeData?.[formData?.brand?.value] : Array.from(new Map(Object.values(localeData).flat().filter(item => item.value !== "").map(item => [item.value, item])).values()) : emptyLocale;

  return (
        <form onSubmit={submitHandler} className={style.brandInside}>
            <FormGroup className={style.formGroup}>
                <Autocomplete
                    options={brandData || null}
                    getOptionLabel={(option) => !option || Object.keys(option).length === 0 ? '' : (option.label || '')}
                    value={formData.brand}
                    onChange={(event, newValue) => handleChange(newValue, 'brand')}
                    isOptionEqualToValue={(option, value) => option.value === value.value || {}}
                    className={style.autocomplete} 
                    size='small'
                    renderInput={(params) => <TextField {...params} label="Select Brand" />} 
                    // filterOptions={(options, { inputValue }) => {
                        //     return inputValue.trim() === '' ? options.filter(item => item.value !== '') : options;
                    // }}
                />
                <Autocomplete
                    getOptionLabel={(option) => !option || Object.keys(option).length === 0 ? '' : (option.label || '')}
                    value={formData.locale}
                    onChange={(event, newValue) => handleChange(newValue, 'locale')}
                    isOptionEqualToValue={(option, value) => option.value === value.value || {}} 
                    // renderInput={(params) => <TextField {...params} value={formData.locale} label="Select Locale" />}
                    className={style.autocomplete}
                    options={localeOptions}
                    size='small' 
                    renderInput={(params) => <TextField {...params} label="Select Locale" />}
                    // filterOptions={(options, { inputValue }) => {
                    //     return inputValue.trim() === '' ? options.filter(item => item.value !== '') : options;
                    // }}
                />
            </FormGroup>
            <LoadingButton className={showSubmit ? '' : style.hiddenSubmit } disabled={!showSubmit} type='submit' variant='contained'><EastIcon aria-hidden="true" /></LoadingButton>
        </form>
  );
};

export default BrandMarketList;